import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { useReport } from '@/modules/analytics/hooks/useReport';
import { useReportDetailUi } from '@/modules/analytics/hooks/useReportDetailUi';

type Props = { reportId: string };

export const ReportDetailHeaderAction = ({ reportId }: Props) => {
  const { t } = useTranslation();
  const { report } = useReport(reportId);
  const { editor, openAddMetric, requestScroll } = useReportDetailUi(reportId);

  if (!report?.metrics.length) {
    return null;
  }

  const handleClick = () => {
    if (editor?.kind === 'add') {
      requestScroll();
      return;
    }
    openAddMetric(reportId);
  };

  return (
    <Button size="sm" onClick={handleClick}>
      <PlusIcon size={16} />
      {t('common.add')}
    </Button>
  );
};
